import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_refresh.svg';
import Icon, { IconProps } from './icon';

const IconRefresh = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconRefresh;
